import { SlideFrame } from '../SlideFrame';

export function Slide02Objective() {
  return (
    <SlideFrame pageNum={2} title="THE OBJECTIVE" banner="A short list of compounders. Owned with conviction. Built to outperform.">
      <div className="h-full flex flex-col items-center justify-center gap-6 px-12">
        <p className="text-[28px] italic text-white text-center max-w-5xl leading-relaxed">
          Our objective is to outperform the S&amp;P 500 by owning a small number of concentrated positions in high-quality companies that compound their earnings growth over time.
        </p>
        <p className="text-[28px] italic text-white text-center max-w-5xl leading-relaxed">
          We pair decades of disciplined money management with the Visualizer, a research and portfolio platform we built in house to sharpen every decision.
        </p>
      </div>
    </SlideFrame>
  );
}
